import JsonFormatter from '@/lib/ScormApi/JsonFormatter'
import ScormAPI2004 from '@/lib/ScormApi/ScormAPI2004'
import CMIInterface, {
  CompletionStatus,
  Credit,
  Entry,
  Mode,
  SuccessStatus, TimeLimitAction
} from "@/lib/ScormApi/Scorm2004/interfaces/CMIInterface"

export default function CMI (api: ScormAPI2004): CMIInterface {
  const __version = "1.0"
  const jsonString = true

  let _completion_status = CompletionStatus.UNKNOWN
  let _credit = Credit.CREDIT
  let _entry = Entry.NONE
  let _mode = Mode.NORMAL
  let _success_status = SuccessStatus.UNKNOWN
  let _time_limit_action = TimeLimitAction.CONTINUE_NO_MESSAGE
  let _exit = ""
  let _completion_threshold = ""
  let _launch_data = ""
  let _learner_id = ""
  let _learner_name = ""
  let _location = ""
  let _max_time_allowed = ""
  let _progress_measure = ""
  let _scaled_passing_score = ""
  let _session_time = ""
  let _suspend_data = ""
  let _total_time = "0"
  let comments_from_learner__children =  "comment,location,timestamp"
  let comments_from_lms__children = "comment,location,timestamp"
  let interactions__children = "id,type,objectives,timestamp,correct_responses,weighting,learner_response,result,latency,description"
  let learner_preference__children = "audio_level,language,delivery_speed,audio_captioning"
  let learner_preference__audio_level = "1"
  let learner_preference__language = ""
  let learner_preference__delivery_speed = "1"
  let learner_preference__audio_captioning = "0"
  let objectives__children = "id,score,success_status,completion_status,progress_measure,description"
  let score__children = "scaled,raw,min,max"
  let score__scaled = ""
  let score__raw = ""
  let score__min = ""
  let score__max = ""

  return {
    get _version () {
      return __version
    },
    set _version (_version) {
      api.throwSCORMError(404)
    },
    get completion_status () {
      return _completion_status
    },
    set completion_status (completion_status) {
      _completion_status = completion_status
    },
    get completion_threshold () {
      return _completion_threshold
    },
    set completion_threshold (completion_threshold) {
      api.isNotInitialized() ? _completion_threshold = completion_threshold : api.throwSCORMError(404)
    },
    get credit () {
      return _credit
    },
    set credit (credit) {
      api.isNotInitialized() ? _credit = credit : api.throwSCORMError(404)
    },
    get entry () {
      return _entry
    },
    set entry (entry) {
      api.isNotInitialized() ? _entry = entry : api.throwSCORMError(404)
    },
    get exit (): any {
      return (!jsonString) ? api.throwSCORMError(405) : _exit
    },
    set exit (exit) {
      _exit = exit
    },
    get launch_data () {
      return _launch_data
    },
    set launch_data (launch_data) {
      api.isNotInitialized() ? _launch_data = launch_data : api.throwSCORMError(404)
    },
    get learner_id () {
      return _learner_id
    },
    set learner_id (learner_id) {
      api.isNotInitialized() ? _learner_id = learner_id : api.throwSCORMError(404)
    },
    get learner_name () {
      return _learner_name
    },
    set learner_name (learner_name) {
      api.isNotInitialized() ? _learner_name = learner_name : api.throwSCORMError(404)
    },
    get location () {
      return _location
    },
    set location (location) {
      _location = location
    },
    get max_time_allowed () {
      return _max_time_allowed
    },
    set max_time_allowed (max_time_allowed) {
      api.isNotInitialized() ? _max_time_allowed = max_time_allowed : api.throwSCORMError(404)
    },
    get mode () {
      return _mode
    },
    set mode (mode) {
      api.isNotInitialized() ? _mode = mode : api.throwSCORMError(404)
    },
    get progress_measure () {
      return _progress_measure
    },
    set progress_measure (progress_measure) {
      _progress_measure = progress_measure
    },
    get scaled_passing_score () {
      return _scaled_passing_score
    },
    set scaled_passing_score (scaled_passing_score) {
      api.isNotInitialized() ? _scaled_passing_score = scaled_passing_score : api.throwSCORMError(404)
    },
    get session_time (): any {
      return (!jsonString) ? api.throwSCORMError(405) : _session_time
    },
    set session_time (session_time) {
      _session_time = session_time
    },
    get success_status () {
      return _success_status
    },
    set success_status (success_status) {
      _success_status = success_status
    },
    get suspend_data () {
      return _suspend_data
    },
    set suspend_data (suspend_data) {
      _suspend_data = suspend_data
    },
    get time_limit_action () {
      return _time_limit_action
    },
    set time_limit_action (time_limit_action) {
      api.isNotInitialized() ? _time_limit_action = time_limit_action : api.throwSCORMError(404)
    },
    get total_time () {
      return _total_time
    },
    set total_time (total_time) {
      api.isNotInitialized() ? _total_time = total_time : api.throwSCORMError(404)
    },
    comments_from_learner: {
      childArray: [],
      get _children () {
        return comments_from_learner__children
      },
      set _children (_children) {
        api.throwSCORMError(404)
      },
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        api.throwSCORMError(404)
      },
      toJSON: new JsonFormatter().apply
    },
    comments_from_lms: {
      childArray: [],
      get _children () {
        return comments_from_lms__children
      },
      set _children (_children) {
        api.throwSCORMError(404)
      },
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        api.throwSCORMError(404)
      },
      toJSON: new JsonFormatter().apply
    },
    interactions: {
      childArray: [],
      get _children () {
        return interactions__children
      },
      set _children (_children) {
        api.throwSCORMError(404)
      },
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        api.throwSCORMError(404)
      },
      toJSON: new JsonFormatter().apply
    },
    learner_preference: {
      get _children () {
        return learner_preference__children
      },
      set _children (_children) {
        api.throwSCORMError(404)
      },
      get audio_level () {
        return learner_preference__audio_level
      },
      set audio_level (audio_level) {
        learner_preference__audio_level = audio_level
      },
      get language () {
        return learner_preference__language
      },
      set language (language) {
        learner_preference__language = language
      },
      get delivery_speed () {
        return learner_preference__delivery_speed
      },
      set delivery_speed (delivery_speed) {
        learner_preference__delivery_speed = delivery_speed
      },
      get audio_captioning () {
        return learner_preference__audio_captioning
      },
      set audio_captioning (audio_captioning) {
        learner_preference__audio_captioning = audio_captioning
      },
      toJSON: new JsonFormatter().apply
    },
    objectives: {
      childArray: [],
      get _children () {
        return objectives__children
      },
      set _children (_children) {
        api.throwSCORMError(404)
      },
      get _count () {
        return String(this.childArray.length)
      },
      set _count (_count) {
        api.throwSCORMError(404)
      },
      toJSON: new JsonFormatter().apply
    },
    score: {
      get _children () {
        return score__children
      },
      set _children (_children) {
        api.throwSCORMError(404)
      },
      get scaled () {
        return score__scaled
      },
      set scaled (scaled) {
        score__scaled = scaled
      },
      get raw () {
        return score__raw
      },
      set raw (raw) {
        score__raw = raw
      },
      get min () {
        return score__min
      },
      set min (min) {
        score__min = min
      },
      get max () {
        return score__max
      },
      set max (max) {
        score__max = max
      },
      toJSON: new JsonFormatter().apply
    },
    toJSON: new JsonFormatter().apply
  }
}
